import { render, staticRenderFns } from "./ListItemMobile.vue?vue&type=template&id=5952283c&scoped=true&lang=pug&"
import script from "./ListItemMobile.vue?vue&type=script&lang=js&"
export * from "./ListItemMobile.vue?vue&type=script&lang=js&"
import style0 from "./ListItemMobile.vue?vue&type=style&index=0&id=5952283c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5952283c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
